import type { I18n } from '@lingui/core';
import { msg } from '@lingui/core/macro';

import $ from '@rover/globals/jquery';

function getWords(s) {
  const trimmedString = s.replace(/(^\s*)|(\s*$)/gi, '');
  if (trimmedString === '') return [];
  return trimmedString.split(/\s+/);
}

function getWordCount(s) {
  return getWords(s).length;
}

function getCharacterCount(s) {
  return s.replace(/(^\s*)|(\s*$)/gi, '').length;
}

($.fn as any).wordCount = function wordCount() {
  return getWordCount($(this).val());
};

function updateWordCount(e, i18n: I18n) {
  const $el = $(e.currentTarget);
  const $counter = $el.siblings().find('.js-word-count-input-counter');
  const $text = $el.siblings().find('.js-word-count-input-text');
  const minCharacters = $el.attr('data-min-characters');

  if (minCharacters != null) {
    const characterCount = getCharacterCount($el.val());
    let charactersNeeded = 0;
    if (minCharacters) charactersNeeded = parseInt(minCharacters, 10) - characterCount;
    $counter.html(Math.max(0, charactersNeeded).toString());

    if (!minCharacters) {
      return;
    }

    if (characterCount === 0) {
      $text.html(i18n._(msg`characters minimum required`));
    } else if (charactersNeeded > 0) {
      $counter.addClass('text-danger');
      $text.addClass('text-danger');
      $text.html(i18n._(msg`more characters needed`));
    } else {
      $counter.removeClass('text-danger');
      $text.removeClass('text-danger');
      $text.html('<i class="text-primary rover-icon rover-icon-in-check-mark">');
      $counter.html('');
    }
  } else {
    const wordCount = getWordCount($el.val());
    let wordsNeeded = 0;
    const minWords = $el.attr('data-min-words');
    if (minWords) wordsNeeded = parseInt(minWords, 10) - wordCount;
    $counter.html(Math.max(0, wordsNeeded).toString());

    if (!minWords) {
      return;
    }

    if (wordCount === 0) {
      $text.html(i18n._(msg`word minimum`));
    } else if (wordsNeeded > 0) {
      $counter.addClass('text-danger');
      $text.addClass('text-danger');
      $text.html(i18n._(msg`more words needed`));
    } else {
      $counter.removeClass('text-danger');
      $text.removeClass('text-danger');
      $text.html('<i class="text-primary rover-icon rover-icon-in-check-mark">');
      $counter.html('');
    }
  }
}

function updateCharCount(evt) {
  const $target: any = $(evt.target);
  $target.siblings().find('.js-char-count-input-counter').html($target.val().length);
}

function initWordCount() {
  $('.js-word-count-input').trigger('input');
}

function initCharCount() {
  $('.js-char-count-input').trigger('input');
}

function init(i18n: I18n) {
  $('.js-word-count-input').on('input', (e) => updateWordCount(e, i18n));
  $('.js-char-count-input').on('input', updateCharCount);
  initWordCount();
  initCharCount();
}

const exportedTextUtilities = {
  init,
  getWords,
  getWordCount,
  getCharacterCount,
  updateWordCount,
  updateCharCount,
  initWordCount,
  initCharCount,
};

export default exportedTextUtilities;
